import React, { useContext, useState } from 'react';
import '../styles/Projects.css';
import { motion } from 'framer-motion';
import { LanguageContext } from '../contexts/LanguageContext';
import { projectsData } from '../data/projectsData';
import ContactBloc from '../components/ContactBloc';

const Projects: React.FC = () => {
    const { language } = useContext(LanguageContext)!;

    const [flippedCards, setFlippedCards] = useState<string[]>([]);

    const handleCardClick = (title: string) => {
        if (flippedCards.includes(title)) {
            setFlippedCards(flippedCards.filter((card) => card !== title));
        } else {
            setFlippedCards([title]);
        }
    };

    const headerVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5 },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i: number) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.12 },
        }),
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="projects"
        >
            <motion.div className="projects-header" variants={headerVariants} initial="hidden" animate="visible">
                <p>{language === 'fr' ? 'Projets' : 'Work'}</p>
                <h1>{language === 'fr' ? `Une attention particulière pour vos projets` : `Special attention for your projects`}</h1>
            </motion.div>

            <div className="projects-flex">
                {projectsData.map((project, index) => (
                    <motion.div
                        key={project.title}
                        className={`project-card ${flippedCards.includes(project.title) ? 'flipped' : ''}`}
                        onClick={() => handleCardClick(project.title)}
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        custom={index}
                    >
                        <div className="card-front">
                            <img src={project.imageUrl} alt={`Homepage project ${project.title}`} className="project-image" />
                            <div className="project-info">
                                <h2>{project.title}</h2>
                                <p>{project.description[language].short}</p>
                            </div>
                        </div>
                        <div className="card-back">
                            <div className="logo-container">
                                <img src={project.logoUrl} alt={`${project.title} logo`} className="project-logo" />
                            </div>
                            <div className="description-container">
                                <p>{project.description[language].long}</p>
                                {project.link && (
                                    <a
                                        href={project.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="projects-link"
                                    >
                                        {language === 'fr' ? 'Visiter le site' : 'Visit the site'}
                                    </a>
                                )}
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>

            <ContactBloc />
        </motion.div>
    );
};

export default Projects;
